/**
 * 許可ドメインリストに引数に渡されたドメインが含まれていることを検証する
 *
 * - 含まれている場合は許可されているため検証は成功し、true となる
 * - 含まれていない場合は許可されていないので検証は失敗し、false となる
 */
export function validateAllowDomains(allowDomainsStr: string, domain: string) {
  if (allowDomainsStr === '') {
    // 空の場合はドメイン許可指定がないので false を返す
    return false;
  }

  if (allowDomainsStr === '*') {
    // * の場合は全てのドメインを許可しているため true を返す
    return true;
  }

  return allowDomainsStr.split(',').includes(domain);
}
